import { NgIf } from '@angular/common';
import { Component, OnChanges } from '@angular/core';

import { ISimpleChanges, changed } from '@frontend/sports/common/core/utils/simple-change';
import { interpolateDoubleBracesString } from '@frontend/sports/common/core/utils/string';

import { DropdownOption } from '../../../dropdown/models';
import { MarketHelpComponent } from '../../market-help/market-help.component';
import { MultiColumnDropdownComponent } from '../multi-column-dropdown.component';
import { ScorecastFooterComponent } from '../scorecast-footer.component';
import { EventDetailsType } from './../scorecast-option-group.model';
import { ScorecastWincastBaseComponent } from './../scorecast-wincast-base.component';

@Component({
    selector: 'ms-wincast-two-way-scorer-option-group',
    templateUrl: './wincast-two-way-scorer-option-group.component.html',
    imports: [NgIf, MarketHelpComponent, MultiColumnDropdownComponent, ScorecastFooterComponent],
})
export class WincastTwoWayScorerOptionGroupComponent extends ScorecastWincastBaseComponent implements OnChanges {
    get warningMessage(): string {
        return this.messages.warningMessageForWinCastTwoway
            ? interpolateDoubleBracesString(this.messages.warningMessageForWinCastTwoway, {
                  Market: this.selectedPlayer?.name!,
              })
            : this.messages.warningMessageForWinCastTwowayKey;
    }

    ngOnChanges(changes: ISimpleChanges<WincastTwoWayScorerOptionGroupComponent>): void {
        if (!this.event) {
            return;
        }

        if (changed(changes.event)) {
            this.mapParticipantImages();
        }

        this.playerMap = this.getPlayersMap();
        this.players = this.mapPlayerGroups();

        this.preSelectOptions();

        if (!this.preSelected) {
            const lowestPriceOption = this.getLowestPriceOption();
            const fixtureParticipantId = this.getFixtureParticipantById(lowestPriceOption.optionGroupId);

            this.selectedPlayer = this.getActiveWithFallback(this.players, (dropdownOption) => dropdownOption.id === fixtureParticipantId);
        }

        this.setActiveOption();
    }

    onPlayerDropdownClick(expanded: boolean): void {
        this.onDropdownClick(expanded, EventDetailsType.Goalscorer);
    }

    override onPlayerChange(market: DropdownOption): void {
        this.selectedPlayer = market;
        super.onPlayerChange(market);
    }
}
